import React, { Component } from 'react';
import { Modal, Button, Col, Image } from 'react-bootstrap';
import { connect } from "react-redux";

import CameraButton from '../buttons/camera_button/CameraButton';
import MainButton from '../buttons/main_button/MainButton';
import { setLoader, setImage, setErrorType, setShowError, setModalButton } from "../../redux/actionCreators";
import './errorModal.css';
import imageProcess from '../../library/ImageProcess';
import { ReactComponent as CrossIcon } from '../../resources/images/red-cross.svg';
import AutoDismissAlert from '../auto_dismiss_alert/AutoDismissAlert';
import { FaWhatsapp, FaExternalLinkAlt, FaRegCopy } from "react-icons/fa";
import config from '../../config/config';
import { textHelper } from '../../helpers/text';
import clockIcon from '../../resources/images/phosphoricons-clock-clockwise.svg';
import { AiOutlineCopy } from "react-icons/ai";
import { ReactComponent as CloseIcon } from '../../resources/images/close.svg';
import WhatsappModal from '../../components/whatsapp_modal/WhatsappModal';



const Tip = ({ value, className }) => (
    <li className={className}>{value}</li>
);

const Tips = ({ tips, className }) => (
    <ul className={className}>
        {tips.map((tip, key) => <Tip key={key} value={tip} className={'tip'} />)}
    </ul>
);

const WHATSAPP_LINK = 'https://wa.me/';
const SUPPORT_NUMBER = config.supportNumber;

class ErrorModal extends Component {

    CAMERA_BUTTON = 1;
    ACCEPT_BUTTON = 2;
    RELOAD_BUTTON = 3;
    RELOAD_AND_ADVANCE_BUTTON = 4;
    SUPPORT_BUTTONS = 5;

    STYLE_NEW_CLASS = 'new-type-error';

    constructor(props) {
        super(props);
        this.state = { 
            alert: null,
            showWhatsappModal: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.errorMessage.button === this.SUPPORT_BUTTONS &&
            prevProps.errorMessage.button !== this.SUPPORT_BUTTONS &&
            !this.state.showWhatsappModal
        ) {
            this.setState({ showWhatsappModal: true });
        }
    }

    handleCloseWhatsappModal = () => {
        this.setState({showWhatsappModal: false})
    }

    getImage = async (event, fileInput) => {
        try {
            const image = await imageProcess.getImageFromFileInput(event, fileInput);
            this.props.setImage(image);
            this.props.setShowError(false);
        } catch (error) {
            console.log(error);
            this.props.setErrorType('defaultImage');
        }
    };

    launchCamera = (inputFile) => {
        inputFile.click();
    };

    closeErrorModal = () => {
        this.props.setShowError(false);
    };

    refreshPage = () => {
        window.location.reload();
    };

    refreshPageAndAdvance = () => {
        var currentUrl = window.location.href;
        const notAdvancedStepInQuery = currentUrl.indexOf('?advanceStep=') === -1;
        const match = currentUrl.match(/\/([^\/?]+)(?:\?.*)?$/);
        const code = match && match[1];
        if(typeof code === 'string' && notAdvancedStepInQuery ){
            var newUrl = currentUrl + `?advanceStep=${code}`;
            window.location.href = newUrl; 
        }else{
            window.location.reload();
        }
    };

    capitalizeFirstLetter(str = '') {
        if ( str === '' ) {
            return '';
        }
        return str[0].toUpperCase() + str.slice(1);
    }

    copiToClipboard = () => {
        navigator.clipboard.writeText(SUPPORT_NUMBER).then(() => {
            console.log('Texto copiado al portapapeles');
        }).catch(err => {
            console.error('Error al copiar el texto: ', err);
        });
    }

    defaultModal(resultButton, closeIconAction, icon, closeIcon) {
        return (
            <Modal
                show={this.props.showError}
                bsSize="large"
                aria-labelledby="contained-modal-title-lg"
                onHide={closeIconAction}
            >
            <div className={'error-modal-container'}>
                <div className={'error-modal-content'}>
                    <Modal.Header>
                        <div className="red-cross" style={{marginRight:"20px"}}>
                                {icon}
                        </div>
                        <Modal.Title id="contained-modal-title-lg">
                            <p>{this.capitalizeFirstLetter(this.props.title)}</p>
                        </Modal.Title>
                        {closeIcon}
                    </Modal.Header>
                    <Modal.Body>
                        <p  className={'principal-message'}>{this.props.principalMessage}</p>
                        <p  className={'secondary-message'} dangerouslySetInnerHTML={{__html: this.props.secondaryMessage}}></p>
                        <Tips className={'tips'} tips={this.props.tips} />
                    </Modal.Body>
                    <Modal.Footer>
                        {resultButton}
                    </Modal.Footer>
                </div>
            </div>
            </Modal>
        )
    }

    modalWithButton(resultButton, closeIconAction) {
        return (
            <Modal
                show={this.props.showError}
                bsSize="large"
                aria-labelledby="contained-modal-title-lg"
                className={this.props.customClass}
                onHide={closeIconAction}
                style={{ display: "flex" , "flexDirection": "column", "justifyContent": "flexEnd"}}
                backdrop={false}
                dialogClassName="transparent-modal"
            >
                <div className={'error-modal-content'}>
                    <Modal.Footer style={{ textAlign: "center" }}>
                        {resultButton}
                    </Modal.Footer>
                </div>
            </Modal>
        )
    }

    handleClickCopyNumber = () => {
        const textToCopy = config.whatsappNumber;
        navigator.clipboard.writeText(textToCopy).then(() => {
            this.showAlert('success', 'Copiado exitosamente')
        }).catch((err) => {
            this.showAlert('danger', 'Error al copiar')
        });
    };

    generateWhatsappLink = () => {
        let message = config.customerServiceWelcomeMessage
        if (this.props.errorMessage.title === 'proceso caducado') {
            message += `\n- Problema: Proceso caducado`
        }
        const errorData = this.props.errorData
        if (errorData.code) {
            message += `\n- Código de Firma: ${errorData.code}`
        }
        if (errorData.rut) {
            message += `\n- RUT: ${textHelper.formatRut(errorData.rut)}`
        }
        if (errorData.plate) {
            message += `\n- Patente: ${errorData.plate}`
        }
        return textHelper.createWhatsAppLink(config.whatsappNumber, message)
    }

    handleClickWhatsapp = () => {
        const whatsappLink = this.generateWhatsappLink()
        window.open(whatsappLink, "_blank");
    }

    handleAlertClose = () => {
        this.setState({ alert: null });
    };

    showAlert = (type, message) => {
        this.setState({
            alert: { type, message },
        });
    };

    handleClickPublicTransference = () => {
        window.location.href = config.af_public_url + this.props.errorData.transferenceRetailCode;
    }

    expiredProcessModal(closeIconAction) {
        const customerServiceHours = config.customerServiceHours
        return (
            <div>
                <Modal
                    show={this.props.showError}
                    onHide={closeIconAction}
                    className="whatsapp-modal"
                >
                    <Modal.Header className="v-center" style={{ paddingBottom: 0 }}>
                        <Col xs={1} className="p-0">
                            <Image
                                src={clockIcon}
                                style={{ width: '25px', height: '25px' }}
                            />
                        </Col>
                        <Col xs={9} className='ph-12'>
                            <Modal.Title className='error-modal-title'>
                                Por seguridad, el tiempo para firmar ha caducado
                            </Modal.Title>
                        </Col>
                        <Col xs={2} className="p-0" style={{textAlign: "end"}}>
                            <CloseIcon onClick={closeIconAction} size={22} color="#595959"/>
                        </Col>
                    </Modal.Header>
                    <Modal.Body>
                        <p className='text-comment'>
                            Puedes retomar el proceso fácilmente:
                        </p>
                        <p className='text-comment'>
                            <b>Opción 1:</b> Si iniciaste la firma desde tu transferencia en la plataforma de Autofact
                        </p>
                        <Button variant="primary" onClick={this.handleClickPublicTransference} className="error-modal-button error-modal-whatsapp-button">
                            Retomar firma digital
                            <FaExternalLinkAlt className="icon-spacing-left" size={16}/>
                        </Button>
                        <p className='text-comment mv-10'>
                            <b>Opción 2:</b> Solo si el enlace de firma fue enviado por nuestro equipo anteriormente y necesitas que lo volvamos a habilitar
                        </p>
                        <Button variant="primary" onClick={this.handleClickWhatsapp} className="error-modal-button error-modal-copy-button">
                            Solicitar por WhatsApp
                            <FaWhatsapp className="icon-spacing-left" size={20} color="#25D366"/>
                        </Button>
                    </Modal.Body>
                    <Modal.Footer>
                        <Col xs={6} className="p-0 text-hint">
                            {customerServiceHours}
                        </Col>
                        <Col xs={6} className="p-0">
                            <Button variant="primary" onClick={this.handleClickCopyNumber} bsStyle="link" className='button-phone'>
                                {config.whatsappNumber}
                                <AiOutlineCopy className="icon-spacing-left" size={18}/>
                            </Button>
                        </Col>
                    </Modal.Footer>
                </Modal>
    
                {this.state.alert && (
                <AutoDismissAlert
                    type={this.state.alert.type}
                    message={this.state.alert.message}
                    onClose={this.handleAlertClose}
                />
                )}
            </div>
            )
    }

    whatsAppModal() {
        const { showWhatsappModal } = this.state;
        return (
            <WhatsappModal
                show={showWhatsappModal}
                handleClose={this.handleCloseWhatsappModal}
            />
        )
    }

    render() {
        let resultButton = '';
        const classSelected = 'blue-button';
        let closeIconAction = this.closeErrorModal;
        const textButton = this.props.textButton || (this.props.customClass ? 'Reintentar' : false) || 'Aceptar';
        let icon = <CrossIcon className={'red-cross'} />;
        let closeIcon = <></>
        switch (this.props.button) {
            case this.CAMERA_BUTTON:
                resultButton = <CameraButton  class={classSelected} isRepeat={true} error={true} text={this.props.textButton || 'Reintentar'} getImage={this.getImage} launchCamera={this.launchCamera} />;
                closeIconAction = this.launchCamera;
                break;
            case this.ACCEPT_BUTTON:
                resultButton =<MainButton text={textButton} class={classSelected} onClick={this.closeErrorModal} />;
                closeIconAction = this.closeErrorModal;
                break;
            case this.RELOAD_AND_ADVANCE_BUTTON:
                resultButton = <MainButton text={textButton} class={classSelected} onClick={this.refreshPageAndAdvance} />
                closeIconAction = this.refreshPage;
                break;
            case this.RELOAD_BUTTON:
                resultButton = <MainButton text='Aceptar' class={classSelected} onClick={ this.refreshPage } />
                closeIconAction = this.refreshPage;
                break;
            case this.SUPPORT_BUTTONS:
                resultButton = <div className={'support-buttons'}>
                                    <MainButton text='Ir a WhatsApp' class={classSelected} icon={<FaExternalLinkAlt className='button-icon' />} onClick={() => window.open(`${WHATSAPP_LINK}${SUPPORT_NUMBER}`, '_blank')} />
                                    <MainButton text='Copiar número' class={classSelected} outline icon={<FaRegCopy className='button-icon' />} onClick={ this.copiToClipboard  } />
                               </div>
                icon = <FaWhatsapp size={32} color="#25D366" />
                closeIcon= <span className='close-icon' onClick={this.closeErrorModal}>X</span>
                closeIconAction = this.closeErrorModal;
                break;
            default:
                resultButton = <MainButton text='Aceptar' class={classSelected} onClick={ this.refreshPage } />
                closeIconAction = this.refreshPage;
                break;
        }

        const companyId = this.props.errorData?.company_id

        if (this.props.modalButton) {
            return this.modalWithButton(resultButton, closeIconAction);
        } else if (this.props.errorMessage.title === 'proceso caducado' && config.directCustomerServiceCompaniesIds.includes(companyId)) {
            return this.expiredProcessModal(closeIconAction);
        } else if (this.SUPPORT_BUTTONS === this.props.errorMessage.button){
            return this.whatsAppModal();
        } else {
            return this.defaultModal(resultButton, closeIconAction, icon, closeIcon)
        }
    }
}

const mapStateToProps = state => {
    return {
        image: state.image,
        showError: state.showError,
        loader: state.loader,
        setErrorType: state.setErrorType,
        modalButton: state.modalButton,
        errorMessage: state.errorMessage,
        errorData: state.errorData,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setModalButton(modalButton) {
            dispatch(setModalButton(modalButton));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);